import { ArrowRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

// Fecha a Home reforçando o próximo passo, sem coletar dados (MVP público).
export const ClosingCTA = () => {
  return (
    <section id="proximo-passo" className="relative py-28 md:py-40 border-t border-white/5">
      <div className="absolute inset-0 grid-lines opacity-40 pointer-events-none" />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal>
          <Overline>Próximo passo</Overline>
          <h2 className="font-display font-extrabold text-4xl md:text-6xl tracking-tighter leading-[0.98] mt-6 max-w-[20ch]">
            Qual processo ainda depende demais da sua equipe?
          </h2>
          <p className="text-neutral-400 text-lg leading-relaxed mt-8 max-w-[52ch]">
            Comece mapeando o processo que mais consome tempo hoje. A partir daí,
            avaliamos os sistemas envolvidos e desenhamos a automação adequada.
          </p>
          <a
            href="/contato"
            data-testid="closing-cta-button"
            className="group mt-10 inline-flex items-center justify-center gap-2 bg-white text-black font-semibold px-7 py-4 rounded-sm hover:bg-neutral-200 active:scale-95 transition-all"
          >
            Mapear meu processo
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </Reveal>
      </div>
    </section>
  );
};
